export const getMedicationsFrag = `
    id
    medicationCode
    customMedication
    serviceId
    customMedicationName
    timesAdministered
    from
    to
    packageTo
    active
    internalNote
    dosingNote
    prescribedBy {
        id
        name
        surname
        titleAfterName
        titleBeforeName
        email
        image
        sex
    }
    dosingPeriod {
        days
        hours
        custom
    }
    dosing {
        morning
        forenoon
        noon
        afternoon
        evening
        night
        hours
    }
`;
